__turbopack_context__.v({
  "button": "SuccessScreen-module-scss-module__w6MwUq__button",
  "downloadPara": "SuccessScreen-module-scss-module__w6MwUq__downloadPara",
  "footer": "SuccessScreen-module-scss-module__w6MwUq__footer",
  "footerCopyright": "SuccessScreen-module-scss-module__w6MwUq__footerCopyright",
  "footerLinks": "SuccessScreen-module-scss-module__w6MwUq__footerLinks",
  "main": "SuccessScreen-module-scss-module__w6MwUq__main",
  "subtitle": "SuccessScreen-module-scss-module__w6MwUq__subtitle",
  "title": "SuccessScreen-module-scss-module__w6MwUq__title",
});
